const choice = [
    {
      label: 'Lion King',
      value: 'lion king',
    },
    {
      label: 'Titanic',
      value: 'titanic',
    },
    {
      label: 'Kuch kuch hota hai',
      value: 'kuch kuch hota hai',
    },
    {
        label: '3 Idiots',
        value: '3 Idiots',
      },
  ];

  export default choice;